import * as Telecom from '@servicetitan/telecom-rtcs-client';
import appManager from '@app/appManager';
import {
  ServiceSessionCreatedEvent,
  ServiceSessionEventType,
} from '../../types/ServiceEvents';
import log from '../../lib/log';
import { getSession } from '../../lib/sessions';
import getTenantId from '../../lib/getTenantId';
import { serviceState } from '../../lib/state';
import getLiveServicesTenantId from '../../lib/getLiveServicesTenantId';

async function handleSessionCreated(event: Telecom.SessionCreatedEvent) {
  log('rtcs:session:created', event);

  const session = getSession(event.conversationId);
  if (session) {
    console.warn('session already exists', event.conversationId);
    return;
  }

  // let's map the tenant id for Live Services
  const tenantId = serviceState.isLiveServicesNetwork
    ? getLiveServicesTenantId(
        event.tenantId,
        event.target.address,
        serviceState.liveServicesMappings,
      )
    : getTenantId(event.tenantId);

  serviceState.sessions[event.conversationId] = {
    ...event,
    createdAt: Date.now(),
    tenantId,
  };

  appManager.events.emit<ServiceSessionCreatedEvent>(
    ServiceSessionEventType.CREATED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      from: event.source.address,
      displayName: event.source.displayName ?? '',
      tenantId,
    },
  );
}

export default handleSessionCreated;
